// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".exc-input[data-v-2b3af56c]{position:relative}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
